import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  selectLoanHistory,
  fetchLoanHistoryActions,
} from '../ducks';
import { apiCallIds as loanApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { loanHistoryStatus } from '../../../common/enums';
import LoanHistory from '../components/LoanHistory';

const mapStateToProps = (state, ownProps) => ({
  loans: selectLoanHistory(state, ownProps.accountId, ownProps.historyStatus),
  isLoading: selectIsInProgress(state, loanApiCallIds.FETCH_LOAN_HISTORY),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchLoanHistory: fetchLoanHistoryActions.request,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class LoanHistoryContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired,
    historyStatus: PropTypes.string.isRequired,
    loans: PropTypes.array,
    count: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      popoverVisible: false,
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
  }

  handleMouseEnter() {
    const { accountId, historyStatus } = this.props;
    if (!this.props.loans) {
      this.props.actions.fetchLoanHistory({
        accountId,
        historyStatus,
        includeInstallments: historyStatus === loanHistoryStatus.AKT
      });
    }
    this.setState({ popoverVisible: true });
  }

  handleVisibleChange(popoverVisible) {
    this.setState({ popoverVisible });
  }

  render() {
    const { loans, isLoading, historyStatus, count } = this.props;

    return (
        <LoanHistory
          loans={loans}
          isLoading={isLoading}
          historyStatus={historyStatus}
          count={count}
          popoverVisible={this.state.popoverVisible}
          handleMouseEnter={this.handleMouseEnter}
          handleVisibleChange={this.handleVisibleChange}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/containers/LoanHistoryContainer.js